export enum Page {
    Loading = 'loading',
    Closed = 'closed',
    New = 'new',
    Top = 'top',
    AreaSelect = 'areaselect',
    PrefectureSelect = 'prefectureselect',
    Drawing = 'drawing',
    Confirm = 'confirm',
    End = 'end',
    Experiment = 'experiment',
    Video = 'video',
    WorkshopAdmin = 'workshopadmin'
};